// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'caret-down';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m14 7-4.764 4.9A.333.333 0 0 1 9 12a.326.326 0 0 1-.236-.1L4 7'
  />
);

export const viewBox = '0 0 18 18';
